import { bubbleSortConfig, bubbleSortRecursiveConfig } from "./bubbleSort/config";
import { mergeSortConfig } from "./mergeSort/config";
import { selectionSortConfig } from "./selectionSort/config";

export const sortingConfigs = [
    bubbleSortConfig,
    selectionSortConfig,
    bubbleSortRecursiveConfig,
    mergeSortConfig
]